import { SUPPORTED_LOCALES } from './defaults'

export type BlockType = 'cards' | 'pageHeader'

export const blockTypes: BlockType[] = ['cards', 'pageHeader']

export type Color = 'primary' | 'secondary' | 'warning' | 'error' | 'info'

export type LocaleMap = Record<(typeof SUPPORTED_LOCALES)[number], string>

export interface MediaAsset {
    id: string
    name: string
    folder: string | null
    url: string
    file_name: string
    mime_type: string
    size: number
    alt_text?: string | null
}

export interface ImageField {
    asset: MediaAsset
    alt: string
}

export interface BaseBlock {
    id?: string | null // uuid — used for Vue :key and ordering
    type: BlockType
}

export interface Eyebrow {
    text: LocaleMap
    color: Color
    isBadge: boolean
    icon: string | null
}

export interface Card {
    align: 'left' | 'center' | 'right'
    orientation: 'horizontal' | 'vertical'
    icon: string
    iconBackground: Color
    iconColor: Color
    title: LocaleMap
    description: LocaleMap
}

export interface CardsBlock extends BaseBlock {
    type: 'cards'
    hasEyebrow: boolean
    eyebrow: Eyebrow
    title: LocaleMap
    description: LocaleMap
    gridOrientation: 'horizontal' | 'vertical'
    hasGlowEffect: boolean
    cards: Card[]
}

export interface PageHeaderBlock extends BaseBlock {
    type: 'pageHeader'
    hasEyebrow: boolean
    eyebrow: Eyebrow
    title: LocaleMap
    description: LocaleMap
    hasImage: boolean
    layout: 'vertical' | 'horizontal'
    imagePosition?: 'left' | 'right' | 'top' | 'bottom'
    image: ImageField | null
    hasBackground: boolean
    backgroundType: 'color' | 'image'
    backgroundColor: string | null
    backgroundImage: ImageField | null
}

export type Block = CardsBlock | PageHeaderBlock

export interface Page {
    id: string
    platform_name: string
    status: 'draft' | 'published'
    title: LocaleMap | null
    description: LocaleMap | null
    slug: LocaleMap | null
    og_title?: LocaleMap | null
    og_description?: LocaleMap | null
    og_image?: ImageField | null
    focus_keyword?: LocaleMap | null
    blocks: Block[]
    created_at: string | null
    updated_at: string | null
}

export interface PlatformMenuItem {
    id: string
    label: LocaleMap
    type: 'link' | 'dropdown'
    children?: PlatformMenuItem[]
    isExternal?: boolean
    url: LocaleMap | null
    target: '_blank' | '_self' | '_parent' | '_top' | null
}

export interface PlatformMenu {
    id: string
    platform_name: string
    type: 'header' | 'footer'
    items: PlatformMenuItem[]
}
